import { v4 as generateID } from '@lukeed/uuid';
export function formatZones(signals) {
    const zones = [];
    for (const signal of signals) {
        const minMax1 = [Number.MAX_VALUE, 0];
        const minMax2 = [Number.MAX_VALUE, 0];
        for (const peak of signal.peaks || []) {
            if (peak.minX < minMax1[0]) {
                minMax1[0] = peak.minX;
            }
            if (peak.maxX > minMax1[1]) {
                minMax1[1] = peak.maxX;
            }
            if (peak.minY < minMax2[0]) {
                minMax2[0] = peak.minY;
            }
            if (peak.maxY > minMax2[1]) {
                minMax2[1] = peak.maxY;
            }
        }
        zones.push({
            id: generateID(),
            x: {
                from: minMax1[0],
                to: minMax1[1],
            },
            y: {
                from: minMax2[0],
                to: minMax2[1],
            },
            signals: [signal],
        });
    }
    return zones;
}
//# sourceMappingURL=formatZone.js.map